// All types are from bid-wizer app ConfigContext/index.ts

type StyleConfigColorPair = {
  background: string;
  color: string;
};

type StyleConfig = {
  primary: StyleConfigColorPair;
  secondary: StyleConfigColorPair;
};

type Image = {
  src: string;
};

export type Biedwijzer_AppConfig = {
  general: {
    privacyStatement: {
      nl: string;
      en: string;
    };
    googleAnalytics4: string;
    facebookPixel: string;
    showConsentCheckbox: boolean;
  };
  design: {
    colors: StyleConfig;
  };
  aboutUs: {
    image: Image;
    heading: {
      nl: string;
      en: string;
    };
    body: {
      nl: string;
      en: string;
    };
  };
  address: {
    image: Image;
  };
  report: {
    cta: {
      helpWithViewing: boolean;
      helpWithBidding: boolean;
    };
  };
};

export type Device = 'mobile' | 'tablet' | 'desktop';
export enum StepName {
  AddressSearch = 'AddressSearch',
  NotForSale = 'NotForSale',
  AboutUs = 'AboutUs',
  HouseConfirmation = 'HouseConfirmation',
  Question1 = 'Question1',
  Question2 = 'Question2',
  Question3 = 'Question3',
  /* This contact form uses OTP and requests the report */
  ContactFormForReportAccess = 'ContactFormForReportAccess',
  /* This contact form does not use OTP and only generates the event */
  BasicContactForm = 'BasicContactForm',
  ContactFormReceived = 'ContactFormReceived',
  Report = 'Report',
}

/**
 * Used to set the preview page on a certain state
 */
export type InitialState = {
  step: StepName;
  previewMode: boolean;
  selectedProperty: {
    forSale: {
      byAccountHolder: boolean;
      askingPrice: number;
      imageUrl: string;
    };
  } | null;
};

/**
 * Default colors are taken from Biedwijzer
 */
export const BIEDWIJZER_DEFAULT_COLORS = {
  primary: {
    background: '#1e2647',
    color: '#ffffff',
  },
  secondary: {
    background: '#ff6900',
    color: '#ffffff',
  },
};
